<template>
  <article class="self-service-card wide-card">
    <h3>会议绑定管理</h3>
    <p v-if="!front.isLoggedIn" class="service-hint">请先登录后再管理分会绑定。</p>
    <p v-else-if="front.needsMembershipChoice" class="service-hint warning">请先选择参与方式（会员/非会员）后再绑定分会。</p>
    <p v-else class="service-hint" :class="{ warning: front.isWithdrawnMember }">{{ front.bindingServiceHint }}</p>

    <div v-if="front.isLoggedIn" class="binding-stats">
      <span class="state-pill success">总会：默认已绑定</span>
      <span class="state-pill">分会：已绑定 {{ front.boundBranchCount }} / {{ front.branchAssociations.length }}</span>
    </div>

    <div
      v-for="item in societyList"
      :key="item.associationId"
      class="binding-card"
      :class="{
        selected: front.isAssociationBound(item),
        'main-society': isMainAssociation(item)
      }"
    >
      <div>
        <strong :class="{ 'is-main-name': isMainAssociation(item) }">{{ displayAssociationName(item) }}</strong>
        <span v-if="isMainAssociation(item)" class="state-pill success">默认已绑定</span>
        <span v-else-if="front.isAssociationBound(item)" class="state-pill success">已绑定</span>
        <p v-if="isMainAssociation(item)" class="service-hint">总会可召开学术年会、发布通知与活动；登录用户默认可查看总会会议。</p>
        <p v-else-if="item.description" class="service-hint">{{ item.description }}</p>
      </div>
      <div class="binding-actions">
        <button
          type="button"
          class="ghost-action compact"
          @click="goSocietyDetail(item)"
        >
          查看详情
        </button>
        <button
          v-if="isMainAssociation(item) || front.isAssociationBound(item)"
          type="button"
          class="ghost-action compact"
          @click="front.goServicesTab('conference', { branch: item.associationId })"
        >
          查看会议
        </button>
        <button
          v-if="isMainAssociation(item)"
          type="button"
          class="ghost-action compact"
          disabled
        >
          无需解绑
        </button>
        <button
          v-else
          type="button"
          class="primary-action compact"
          :disabled="!front.isLoggedIn || !front.canBindBranch"
          @click="front.toggleAssociation(item)"
        >
          {{ front.isAssociationBound(item) ? '解绑分会' : '绑定分会' }}
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import {
  branchSitePath,
  displayAssociationName,
  isMainAssociation,
  sortSocietiesMainFirst
} from '../../data/branchSite'

export default {
  name: 'BindingCard',
  inject: ['front'],
  computed: {
    societyList() {
      const list = sortSocietiesMainFirst(this.front.bindableAssociations || [])
      const main = this.front.mainSocietyAssociation
      if (main && !list.some(item => isMainAssociation(item))) {
        return [main, ...list]
      }
      return list
    }
  },
  methods: {
    branchSitePath,
    displayAssociationName,
    isMainAssociation,
    goSocietyDetail(item) {
      const main = this.front.mainSocietyAssociation
      const id = isMainAssociation(item)
        ? (main && main.associationId) || item.associationId || 1
        : item.associationId
      this.front.goPath(branchSitePath(id, 'home'))
    }
  }
}
</script>

<style scoped>
.is-main-name {
  font-weight: 700;
}
</style>
